// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"animation-styles-module--fadeIn--K09OJ","fadeOut":"animation-styles-module--fadeOut--3Xdqd"};